module.exports = __webpack_public_path__ + "img/symbol_12.e56a4244.png";